/**
 * Shared "Setup Complete" step (stepperStep === 4).
 * Used by setupPage (full screen) and performanceOnboardingBanner (modal).
 * The only difference is onProceedToDemo (navigate vs close modal).
 */
import { Box, Button, Typography } from "@mui/material";
import { muiTheme } from "../theme/theme";

export default function SetupSuccessStep({ onProceedToDemo }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      gap="32px"
      sx={{
        fontWeight: 600,
        fontSize: "1.5rem",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="12px"
      >
        <Box
          component="img"
          src="/Success Animation.gif"
          alt="Setup Complete"
          sx={{
            width: { xs: "120px", sm: "160px" },
            height: "auto",
            objectFit: "contain",
          }}
        />
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "1.5rem",
            color: "var(--text-primary, #000000DE)",
          }}
        >
          ✅ Setup Complete!
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            color: "var(--text-secondary, #00000099)",
          }}
        >
          Our team is reviewing your information and setting things up — this
          usually takes 2–3 business days. We’ll notify you as soon as your
          personal dashboard is ready. <br />
          <br />
          In the meantime, you’ll be taken to a demo account to explore the
          platform.
        </Typography>
      </Box>
      <Button
        variant="contained"
        sx={{
          textTransform: "none",
          borderRadius: "4px",
          backgroundColor: muiTheme.palette.primary.main,
          "&:hover": { backgroundColor: "#4C63D7" },
        }}
        onClick={onProceedToDemo}
      >
        Proceed To Demo Account
      </Button>
    </Box>
  );
}
